module.exports = __webpack_public_path__ + "static/media/bell-active.740ea6fe.svg";